"use strict";
/**
 * Created by david.petrosyan
 * on 18/10/2018.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ResponseData = /** @class */ (function () {
    function ResponseData() {
    }
    /**
     * @public
     */
    ResponseData.prototype.getTotalRowCount = function () {
        return this._totalRowCount;
    };
    /**
     * Set the meta of a response.
     * @param {number} totalRowCount - Number of total count of filtered data.
     * @public
     */
    ResponseData.prototype.setTotalRowCount = function (totalRowCount) {
        this._totalRowCount = totalRowCount;
    };
    /**
     * @public
     */
    ResponseData.prototype.getData = function () {
        return this._data;
    };
    /**
     * Set the data of a response.
     * @param {T} data - The data of a response.
     * @public
     */
    ResponseData.prototype.setData = function (data) {
        this._data = data;
    };
    return ResponseData;
}());
exports.ResponseData = ResponseData;
//# sourceMappingURL=response-data.model.js.map